import React, { useEffect, useState } from "react"
import NavigationBar from "../component/NavigationBar"
import ListingMain from "./listing/ListingMain"
import KunjungiKami from "./about-us/KunjungiKami"
import { Card, Typography, Button } from "@material-tailwind/react"
import Footer from "../component/Footer"
import { WBInput } from "../component/WBInput"
import { FaSistrix } from "react-icons/fa6"
import Pill from "../component/Pill"
import { setSearchObj } from "../../helper/localStorage"
import AgentMain from "./agents/AgentMain"
import { getAboutUs, getBanner } from "../../service/AboutUsService"

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

function Main ({

}) {
    const [ filter, setFilter ] = useState({
        queryName: '',
        type: 'all',
        listingStatus: 'all'
    })
    const [ bannerImage, setBannerImage ] = useState([])
    const [ aboutUs, setAboutUs ] = useState({
        title: "",
        subtitle: "",
        images: [],
        office: []
    })

    useEffect(() => {
        loadBannerImage()
        loadAboutUs()
    }, [])

    const loadBannerImage = async () => {
        let { data, error } = await getBanner()
        if (data) { setBannerImage(data) }
    }

    const loadAboutUs = async () => {
        let { data, error } = await getAboutUs()
        if (data) { setAboutUs({ office: data.office.images }) }
    }
    
    const onChange = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e
        }))
    }
    return (
        <>
            <NavigationBar fixed/>
            <div className="mt-6 pb-8 px-4 md:px-12 center">
                {/* <div className="!flex mb-[60vh] h-[55vh] w-full items-center justify-between px-10"> */}
                <div className="!flex mb-[2.5rem] md:mb-[20vh] md:h-[50vh] w-full items-center justify-between">
                    {/* <img
                        width={1200}
                        height={1200}
                        // src="https://images.unsplash.com/photo-1653974123177-fe9c05fb79e6?q=80&w=2832&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                        // src="https://images.unsplash.com/photo-1523217582562-09d0def993a6?q=80&w=2680&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                        src={bannerImage[0]}
                        alt="bg-img"
                        className="hidden md:block absolute inset-0 ml-auto w-[920px] h-[70vh] rounded-bl-[100px] object-cover object-center sm:top-20"
                    /> */}
                    {
                        bannerImage.length > 1 ?
                            <div className="hidden md:block absolute inset-0 ml-auto w-[920px] h-[70vh] rounded-bl-[100px] object-cover object-center">
                                <Swiper
                                    loop={true}
                                    spaceBetween={40}
                                    pagination={{clickable: true}}
                                    modules={[Pagination]}
                                    className="hidden md:block absolute inset-0 ml-auto w-[920px] h-[70vh] rounded-bl-[100px] object-cover object-center sm:top-20"
                                >
                                    {
                                        bannerImage.map( (value, index) => {
                                            return (
                                            <SwiperSlide key={index}>
                                                <img
                                                    width={768}
                                                    height={768}
                                                    src={value}
                                                    alt={index}
                                                    className="rounded-bl-[100px] sm:top-20"
                                                />
                                            </SwiperSlide>
                                            )
                                        })
                                    }
                                </Swiper>
                            </div>
                        : <img className="hidden md:block absolute inset-0 ml-auto w-[920px] h-[70vh] rounded-bl-[100px] object-cover object-center sm:top-20" src={bannerImage[0]} />
                    }
                    <div className="container md:w-[100%] lg:w-[50%] align-left md:mt-[10vh] z-[2]">
                        <div className="text-center place-items-left lg:text-left">
                            <Card className="col-span-full rounded-xl border border-white bg-white/90 w-full md:p-8 shadow-lg shadow-black/10 backdrop-blur-sm backdrop-saturate-200">
                                <div className="hidden md:block">
                                    {/* <Typography
                                        variant="h1"
                                        color="blue-gray"
                                        className="sm:text-sm lg:text-5xl !leading-snug text-3xl lg:max-w-3xl"
                                    >Maxx Property</Typography> */}
                                    <div className="grid grid-cols-1 items-center gap-4">
                                        <WBInput className={"mt-2"} placeholder={"Cari Nama atau Lokasi"} onChange={(e) => {
                                            onChange({ queryName: e.currentTarget.value })
                                        }} onEnterClick={() => {
                                            // loadProperties({ queryName })
                                        }} icon={<FaSistrix className="mt-2.5"/>} />
                                        <div className="text-left">
                                            <div className="text-black text-[14px] font-bold">Tipe Properti</div>
                                            <div className="mt-1 flex overflow-auto scrollbar-hide cursor-pointer">
                                                <Pill selected={filter.type == "all" ? true : false} onClick={() => {
                                                    onChange({ type: 'all' })
                                                }} text={"Semua"}/>
                                                <Pill selected={filter.type == "apartment" ? true : false} onClick={() => {
                                                    onChange({ type: 'apartment' })
                                                }} text={"Apartement"}/>
                                                <Pill selected={filter.type == "rumah" ? true : false} onClick={() => {
                                                    onChange({ type: 'rumah' })
                                                }} text={"Rumah"}/>
                                                <Pill selected={filter.type == "ruko" ? true : false} onClick={() => {
                                                    onChange({ type: 'ruko' })
                                                }} text={"Ruko"}/>
                                                <Pill selected={filter.type == "gudang" ? true : false} onClick={() => {
                                                    onChange({ type: 'gudang' })
                                                }} text={"Gudang"}/>
                                                <Pill selected={filter.type == "tanah" ? true : false} onClick={() => {
                                                    onChange({ type: 'tanah' })
                                                }} text={"Tanah"}/>
                                            </div>
                                        </div>
                                        <div className="text-left">
                                            <div className="text-black text-[14px] font-bold">Kondisi Properti</div>
                                            <div className="mt-1 flex overflow-auto scrollbar-hide cursor-pointer">
                                                <Pill selected={(filter.listingStatus == "" || filter.listingStatus == "all") ? true : false} onClick={() => {
                                                    onChange({ listingStatus: 'all' })
                                                }} text={"Semua"}/>
                                                <Pill selected={filter.listingStatus == "new" ? true : false} onClick={() => {
                                                    onChange({ listingStatus: 'new' })
                                                }} text={"Baru"}/>
                                                <Pill selected={filter.listingStatus == "secondary" ? true : false} onClick={() => {
                                                    onChange({ listingStatus: 'secondary' })
                                                }} text={"Secondary"}/>
                                            </div>
                                        </div>
                                        <div className="mt-2 flex justify-center lg:justify-end min-w-[180px]">
                                            <Button className="bg-gold w-full" color="gray" onClick={() => {
                                                setSearchObj(filter)
                                                window.location.href = "/listing"
                                            }}>Temukan Properti</Button>
                                        </div>
                                    </div>
                                </div>
                                <div className="md:hidden p-2">
                                    <div>
                                        <WBInput placeholder={"Cari Nama atau Lokasi"} onChange={(e) => {
                                            onChange({ queryName: e.currentTarget.value })
                                        }} onEnterClick={() => {
                                            // loadProperties({ queryName })
                                        }} icon={<FaSistrix/>} />
                                        <div className="mt-2 text-left">
                                            <div className="text-black text-[14px] font-bold">Tipe Properti</div>
                                            <div className="mt-1 flex overflow-auto scrollbar-hide cursor-pointer">
                                                <Pill selected={filter.type == "all" ? true : false} onClick={() => {
                                                    onChange({ type: 'all' })
                                                }} text={"Semua"}/>
                                                <Pill selected={filter.type == "apartment" ? true : false} onClick={() => {
                                                    onChange({ type: 'apartment' })
                                                }} text={"Apartement"}/>
                                                <Pill selected={filter.type == "rumah" ? true : false} onClick={() => {
                                                    onChange({ type: 'rumah' })
                                                }} text={"Rumah"}/>
                                                <Pill selected={filter.type == "ruko" ? true : false} onClick={() => {
                                                    onChange({ type: 'ruko' })
                                                }} text={"Ruko"}/>
                                                <Pill selected={filter.type == "gudang" ? true : false} onClick={() => {
                                                    onChange({ type: 'gudang' })
                                                }} text={"Gudang"}/>
                                                <Pill selected={filter.type == "tanah" ? true : false} onClick={() => {
                                                    onChange({ type: 'tanah' })
                                                }} text={"Tanah"}/>
                                            </div>
                                        </div>
                                        <div className="text-left">
                                            <div className="text-black text-[14px] font-bold">Kondisi Properti</div>
                                            <div className="mt-1 flex overflow-auto scrollbar-hide cursor-pointer">
                                                <Pill selected={(filter.listingStatus == "" || filter.listingStatus == "all") ? true : false} onClick={() => {
                                                    onChange({ listingStatus: 'all' })
                                                }} text={"Semua"}/>
                                                <Pill selected={filter.listingStatus == "new" ? true : false} onClick={() => {
                                                    onChange({ listingStatus: 'new' })
                                                }} text={"Baru"}/>
                                                <Pill selected={filter.listingStatus == "secondary" ? true : false} onClick={() => {
                                                    onChange({ listingStatus: 'secondary' })
                                                }} text={"Secondary"}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 flex justify-center lg:justify-start">
                                        <Button className="bg-gold w-full" color="gray" onClick={() => {
                                            setSearchObj(filter)
                                            window.location.href = "/listing"
                                        }}>Temukan Properti</Button>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
                <ListingMain />
                <AgentMain />
            </div>
            <KunjungiKami office={aboutUs.office} />
            <Footer showSiteMap/>
        </>
    )
}

export default Main